import React from 'react';
import styles from './UiSpinner.module.scss';

const UiSpinner = () => {
  return <div className={styles.loader} />;
};

export default UiSpinner;
